import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/i18n';

import { SearchProvider } from '@/context/search';

// components
import SearchApp from '@/components/organisms/Search/SearchApp';

export default () => {
  const el = document.getElementById('js-search-r-entry');
  if (el) {
    i18n.loadNamespaces(['listing', 'search'], () => {
      const App = () => (
        <I18nextProvider i18n={i18n}>
          <Suspense fallback={<div />}>
            <SearchProvider>
              <SearchApp {...el.dataset} />
            </SearchProvider>
          </Suspense>
        </I18nextProvider>
      );
      ReactDOM.render(<App />, el);
    });
  }
};
